import React, { useMemo } from 'react';
import { cn } from '../../../utils/tailwind';
import { IconFacebook } from '../../app/icons/facebook';
import { IconInstagram } from '../../app/icons/instagram';
import { IconDiscord } from '../../app/icons/discord';

interface SocialPropsInterface {
    type: 'Facebook' | 'Instagram' | 'Discord';
    link: string;
    neutral?: boolean;
}

export const Social: React.FC<SocialPropsInterface> = ({ type, link, neutral = false }) => {
    const icon = useMemo(() => {
        if (type === 'Facebook') {
            return <IconFacebook />;
        }
        if (type === 'Instagram') {
            return <IconInstagram />;
        }
        if (type === 'Discord') {
            return <IconDiscord />;
        }
        return null;
    }, [type]);

    return (
        <div
            className={cn(
                '[&_a]:flex [&_a]:h-[4.6rem] [&_a]:w-[4.6rem] [&_a]:items-center [&_a]:justify-center [&_a]:rounded-full [&_a]:border [&_a]:transition-colors [&_a]:leading-[0] [&_i]:h-[2rem] [&_i]:w-[2rem]',
                neutral
                    ? '[&_a]:border-[#d9cdc5] [&_a]:text-web-copy [&_a:hover]:bg-[#d9cdc5]/40'
                    : '[&_a]:border-neutral-gray/30 [&_a]:text-brand-secondary [&_a:hover]:bg-brand-primary-dark [&_a:hover_i]:text-neutral-white',
            )}
        >
            <a href={link} title={type} target="_blank" rel="noreferrer">
                {icon}
            </a>
        </div>
    );
};
